<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-lg-12">
          <div class="element-box mb-0">
            <form @submit="refresh">
              <h5 class="form-header">Revisión de Piso</h5>
              <P></P>
              <div class="row">
                <div class="col-sm-8">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.producto &&
                          current.errors.producto.length > 0,
                      }"
                    ></label>
                    <ProductoSelectComponentV2
                      @onChangeProducto="onChangeProducto"
                      :current="current"
                    ></ProductoSelectComponentV2>
                    <small
                      v-if="current.errors && current.errors.producto"
                      class="form-text text-danger"
                      >{{ current.errors.producto[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-4 align-text-bottom">
                  <div class="element-box-content">
                    <br />
                   <br>
                    <InputCamaraBarcodeComponent @cerrandomodal="cerrarmodalescaner" />
                  </div>
                </div>
                <div class="col-md-12">
                  <TiendaSelectComponent :current="current" />
                </div>
              </div>
              <div class="form-buttons-w">
                <router-link
                  v-if="current.producto"
                  class="btn btn-outline-info"
                  :to="{
                    name: 'cat-productos-editar',
                    params: { sku: current.producto.sku },
                  }"
                >
                  <i class="fa fa-arrow-left"></i>
                  Ir al Producto
                </router-link>
                <button class="btn btn-md btn-success" type="submit">
                  Refrescar
                </button>
                &nbsp;
              </div>
            </form>

            <div class="row"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th rowspan="2">Sku</th>
                      <th rowspan="2"></th>
                      <th rowspan="2">Tienda</th>
                      <th colspan="4" class="text-center">Unidades Vendidas</th>
                      <th rowspan="2">Minimo</th>
                      <th rowspan="2">Maximo</th>
                      <th rowspan="2">Existencia</th>
                    </tr>
                    <tr>
                      <th class="text-right">Hace 3 Semana</th>
                      <th class="text-right">Hace 2 Semana</th>
                      <th class="text-right">Hace 1 Semana</th>
                      <th class="text-right">Semana Actual</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in datos" :key="item.id">
                      <td style="color: DodgerBlue">
                        {{ item.producto_id }}
                      </td>
                      <td>
                        {{ item.nombre_producto }}
                      </td>
                      <td>
                        {{ item.tienda_id }}
                      </td>
                      <td>
                        {{ item.unidades_hace3semanas }}
                      </td>
                      <td class="text-right">
                        {{ item.unidades_hace2semanas }}
                      </td>
                      <td class="text-right">
                        {{ item.unidades_hace1semanas }}
                      </td>
                      <td class="text-right">
                        {{ item.unidades_estasemana }}
                      </td>
                      <td class="text-right">
                        {{ item.minimo }}
                      </td>
                      <td class="text-right">
                        {{ item.maximo }}
                      </td>
                      <td class="text-right">
                        {{ item.existencia }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";
import InputCamaraBarcodeComponent from "@/components/commons/InputCamaraBarcodeComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
    ProductoSelectComponentV2,
    InputCamaraBarcodeComponent,
  },
  data() {
    return {
      producto: "",
      codigo_barra: null,
      current: {
        producto: null,
        tienda: '06',
        errors: {
          productos: null,
          fecha_inicial: null,
          fecha_final: null,
        },
      },
      mounting: true,
      datos: [],
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.tienda) {
        this.current.tienda = this.$route.params.tienda;
      }
    },
  },
  mounted() {
    let self = this;
    if (this.$route.params.tienda) {
      self.current.tienda = this.$route.params.tienda;
    }
    if (this.$route.params.sku) {
      self.refreshProducto(this.$route.params.sku);
    }
    
    
  },
  methods: {
    onChangeProducto(producto) {
      let self = this;
      self.refreshProducto(self.current.producto.sku);
      // self.refreshUnidadMedida(producto);
    },
    refreshProducto(sku) {
      let self = this;
      let _p = {
        render_precios: false,
      };
      ProductosService.getById(sku, _p).then((response) => {
        self.current.producto = response.data;
        if (self.mounting){
          this.refresh();
          this.mounting= false;
        }
      });
    },
    refresh(e) {
      if (e) {
        e.preventDefault();
      }
      let self = this;
      let params = {
        sku: self.current.producto.sku,
        tienda: self.current.tienda,
      };

      DynamicService.getAction(
        "cat",
        "productos",
        self.current.producto.sku,
        "ventas_ultimas_semanas_por_sku",
        params
      )
        .then((res) => {
          self.datos = res.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },

    cerrarmodalescaner(obj){
      console.log(obj);
      let self = this;
      self.codigo_barra = obj.barcode;

      let params = {
        'filter[search]': self.codigo_barra,
      };

      DynamicService.fetch(
        "cat",
        "productos",
        params
      )
        .then((res) => {
          console.log(res.data)
          if (res.data.results.length == 0 ){
            self.datos = [];
            alert('Barra no encontrada')
          }else{
            let routeUrl = self.$router.resolve({
              name: "inventario-reportes-revision-piso",
              params: { 
                sku: self.codigo_barra,
                tienda: self.tienda
              },
            });
            window.location.href = routeUrl.href;
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
        
    }
  },
};
</script>
